import { Icon, type IconProps } from "@chakra-ui/react";

const CloseIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 34 34"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M17 1.5C25.5604 1.5 32.5 8.43959 32.5 17C32.5 25.5604 25.5604 32.5 17 32.5C8.43959 32.5 1.5 25.5604 1.5 17C1.5 8.43959 8.43959 1.5 17 1.5Z"
				fill="black"
				fillOpacity="0.8"
			/>
			<path
				d="M17 1.5C25.5604 1.5 32.5 8.43959 32.5 17C32.5 25.5604 25.5604 32.5 17 32.5C8.43959 32.5 1.5 25.5604 1.5 17C1.5 8.43959 8.43959 1.5 17 1.5Z"
				stroke="white"
				strokeWidth="3"
			/>
			<path
				d="M21 13L13 21M13 13L21 21"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};

export default CloseIcon;
